export const DESTINATION_MODE = Object.freeze({ SEARCHING: "searching", SELECTED: "selected" });

export function shouldFetchDestinationSuggestions(mode, value = "") {
  return mode === DESTINATION_MODE.SEARCHING && value.trim().length >= 3;
}
